import { Monitor, Mobile } from 'iconsax-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Card } from '@/components/ui/card'
import { weCheckPalette } from '@/utils/palette/weCheckPalette'

interface MobileFeedbackScreenProps {
  className?: string
}

const MobileFeedbackScreen: React.FC<MobileFeedbackScreenProps> = ({
  className = '',
}) => {
  const { t } = useTranslation()

  return (
    <div
      className={`flex items-center justify-center min-h-[400px] p-6 ${className}`}
    >
      <Card className="max-w-md w-full text-center p-8">
        <div className="flex justify-center gap-4 mb-6">
          <Monitor size="48" color={weCheckPalette.primary} variant="Bold" />
          <Mobile size="48" color={weCheckPalette.primary} variant="Outline" />
        </div>

        <h2 className="text-xl font-bold text-neutral-950 dark:text-neutral-50 mb-4">
          {t('dashboard.batchSearch.desktopOnlyTitle')}
        </h2>

        <p className="text-neutral-600 dark:text-neutral-400 leading-relaxed">
          {t('dashboard.batchSearch.desktopOnlyMessage')}
        </p>
      </Card>
    </div>
  )
}

export default MobileFeedbackScreen
